import browserUpdate from 'browser-update';

browserUpdate({
  style: 'bottom',
});
